import React from 'react';
import ComingSoon from './ComingSoon';

// TODO(data): wire to PHP getHolidays (exists) — Phase 3.
const Holidays = () => <ComingSoon title="חגים ומועדים" note="ניהול החגים והמועדים יתווסף בקרוב." />;

export default Holidays;
